<span class="font-medium-title-large">Datei umbenennen</span>

<form [formGroup]="form" class="align-self-stretch flex-c gap-16">
  <div class="flex-r gap-16">
    <div class="input-simple flex-1-1-0">
      <label for="fileName" class="input-label">
        Dateiname*
        @if (fileExtension) {
          <span class="extension-hint">(Endung: .{{ fileExtension }})</span>
        }
      </label>
      <input
        type="text"
        id="fileName"
        name="fileName"
        class="input-field"
        placeholder="Dateiname"
        formControlName="fileName"
        (keydown.enter)="onRename()" />
      <app-error-message [formField]="form.get('fileName')"></app-error-message>
    </div>
  </div>
</form>

<div class="flex-r gap-16 justify-center padding-top-16">
  <button
    type="button"
    class="inwi-icon-text-button-large-secondary"
    (click)="onCancel()">
    <div class="button-content">
      <div class="button-icon">
        <i class="fa-regular fa-times"></i>
      </div>
      <div class="button-text">Abbrechen</div>
    </div>
  </button>
  <button
    type="submit"
    class="inwi-icon-text-button-large-primary"
    (click)="onRename()"
    [disabled]="form.invalid">
    <div class="button-content">
      <div class="button-icon">
        <i class="fa-regular fa-check"></i>
      </div>
      <div class="button-text">Umbenennen</div>
    </div>
  </button>
</div>
